/** @jsxRuntime classic */
/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { css, jsx } from '@emotion/react';
import Text from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import { englishTimeToSwedishTime } from '../../i18n/helper';
import { useIsMobile } from '../../utils/hooks';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

export default function GuestBookingInfo({ info }) {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  let bookingLocation = info?.locations?.[0];
  let bookingLocationIcon;
  if (bookingLocation.value === 'google_meet') {
    bookingLocationIcon = (
      <img
        src="/google_meet_icon.svg"
        alt="Google Meet"
        width="24"
        height="24"
      />
    );
  } else if (bookingLocation.value === 'physical') {
    bookingLocationIcon = <BusinessOutlinedIcon />;
  }
  return (
    <div
      css={css`
        background: var(--background-white);
        padding: 1rem;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <Text variant="h5">{info.name}</Text>
      <Text variant="subtitle2" color="text.secondary">
        {info.description || t('Ingen beskrivning')}
      </Text>
      <div
        css={css`
          display: flex;
          align-items: center;
          margin-top: 0.5rem;
          flex-direction: ${isMobile ? 'column' : 'row'};
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
          `}
        >
          <Typography
            variant="body1"
            component="span"
            css={css`
              color: var(--text-secondary);
              margin-right: 0.5rem;
            `}
          >
            {t('Tid')}:
          </Typography>
          <AccessTimeIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          <Typography
            variant="body1"
            component="span"
            css={css`font-size; 14px; letter-spacing: 0.1px; color: #000000DE; margin-left: 0.5rem;`}
          >
            {info.duration} {t(englishTimeToSwedishTime(info.durationType))}
          </Typography>
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            margin-top: ${isMobile ? '0.5rem' : '0'};
          `}
        >
          <Typography
            variant="body1"
            component="span"
            css={css`
              color: var(--text-secondary);
              margin-right: 0.5rem;
              margin-left: 1rem;
            `}
          >
            {t('Plats')}:
          </Typography>
          {bookingLocationIcon}
          <Typography
            variant="body1"
            component="span"
            css={css`
              color: var(--text-secondary);
              margin-left: 0.5rem;
            `}
          >
            {bookingLocation.value === 'physical'
              ? bookingLocation?.data?.address
              : bookingLocation.label}
          </Typography>
        </div>
      </div>
    </div>
  );
}
